import React from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
//import Audionauts from "../../Photos/audionautas_logo.jpeg";

const UserProfile = () => {

    const Navigate = useNavigate();

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : null
    const allowed = decodedToken && decodedToken.first_survey === false && window.localStorage.getItem("OpenAccess") ? JSON.parse(window.localStorage.getItem("OpenAccess")) : decodedToken ? decodedToken.first_survey : null

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                {decodedToken ?
                <div className='UserProfileWhiteBox UserProfileWhiteBoxFlex'>
                    <div className='UserProfileWhiteBoxLeft'>
                        <img alt="" className='UserProfileWhiteBoxLeftMainImage' src="https://static.yomecontrolo.cl/public/B2B/UserProfileCalculatorHomeImage.png" />
                        <div className='UserProfileWhiteBoxLeftTexts'>
                            <h4 className='UserProfileUpTitle'>Bienvenid@ {decodedToken.name}</h4>
                            <h1 className='UserProfileTitle'>Toma el control de tu salud</h1>
                            <div className='UserProfileUpTitle'>Para vivir más y mejor</div>
                        </div>  
                    </div>
                    <div className='UserProfileWhiteBoxRight'>
                            <div className='UserProfileBigButton' style={{backgroundColor:"#F2F2FF"}} onClick={() => {Navigate("/perfil-de-usuario/antecedentes-medicos"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Perfil de Salud</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Tu historial médico</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage7VectNoBG.png" />
                                </div>
                            </div>
                            {allowed ?
                            <div className='UserProfileBigButton UserProfileBigButtonExtra' onClick={() => {Navigate("/packs-de-examenes"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Emitir orden de exámenes</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Diseñados para ti</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                                </div>
                            </div>
                            :
                            <div className='UserProfileBigButton UserProfileBigButtonExtra' style={{pointerEvents:"none"}}>
                                <div className='UserProfileBigButtonDisabledText'>Bloqueada hasta ingresar datos en Perfil de Salud</div>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Emitir orden de exámenes</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Diseñados para ti</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                                </div>
                            </div>
}
                            {allowed ?
                            <div className='UserProfileBigButton' style={{backgroundColor:"#CFF9FF"}} onClick={() => {Navigate("/perfil-de-usuario/calculadora-de-salud"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Mide tus riesgos</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Para prevenir enfermedades</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect.svg" />
                                </div>
                            </div>
                            :
                            <div className='UserProfileBigButton' style={{backgroundColor:"#CFF9FF", pointerEvents:"none"}}>
                                <div className='UserProfileBigButtonDisabledText'>Bloqueada hasta ingresar datos en Perfil de Salud</div>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Mide tus riesgos</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Para prevenir enfermedades</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect.svg" />
                                </div>
                            </div>
}
                            {opening && allowed ?
                            <div className='UserProfileBigButton UserProfileBigButtonExtra' onClick={() => {Navigate("/perfil-de-usuario/informe-de-salud"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Informe de Salud</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Descárgalo</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                                </div>
                            </div>
                            : 
                            <div className='UserProfileBigButton UserProfileBigButtonExtra' style={{pointerEvents:"none"}}>
                                <div className='UserProfileBigButtonDisabledText'>{!allowed ? "Bloqueada hasta ingresar datos en Perfil de Salud" : "Bloqueada hasta completar encuesta Hábitos de Vida"}</div>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Informe de Salud</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Descárgalo</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                                </div>
                            </div>
                            }
                            {allowed ?
                            <div className='UserProfileBigButton' style={{backgroundColor:"#CCF"}} onClick={() => {Navigate("/plan-de-intervencion"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Recomendaciones</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Para mejorar tu salud</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage4_3Vect.svg" />
                                </div>
                            </div>
                            :
                            <div className='UserProfileBigButton' style={{backgroundColor:"#CCF", pointerEvents:"none"}}>
                                <div className='UserProfileBigButtonDisabledText'>Bloqueada hasta ingresar datos en Perfil de Salud</div>
                                <div className='UserProfileBigButtonBackTexts'>
                                    <h4 className='UserProfileBigButtonBackUpText'>Recomendaciones</h4>
                                    <div className='UserProfileBigButtonBackUnderText'>Para mejorar tu salud</div>
                                </div>
                                <div className='UserProfileBigButtonBackImageDiv'>
                                    <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage4_3Vect.svg" />
                                </div>
                            </div>
}
                    </div>
                </div>
                : null}
            </div>
        </div>
    );
};

export default UserProfile;